/* eslint-disable jsx-a11y/alt-text */
import Image, { ImageProps } from 'next/image';
import * as S from './ImageBox.styles';
import { ImageBoxProps, ImageBoxPropsWithSrc } from './ImageBox.types';

export const ImageBox: React.FC<ImageBoxProps | ImageBoxPropsWithSrc> = ({
  filename,
  src,
  alt = '',
  width = 20,
  height = 20,
  iconWidth,
  iconHeight,
  onlyIcon = false,
  imageStyle = {},
  priority,
  ...props
}) => {
  const imageProps: ImageProps = {
    src: src ?? `/images/${filename ?? ''}`,
    alt,
    width: iconWidth ?? width,
    height: iconHeight ?? height,
    style: { objectFit: 'cover', ...imageStyle },
    priority,
  };
  const { children, ...rest } = props;

  return onlyIcon ? (
    <Image {...imageProps} />
  ) : (
    <S.Box width={width} height={height} {...rest}>
      {children}
      <Image {...imageProps} />
    </S.Box>
  );
};
